import { IPIRANGA_PROMOTION_AVAILABLE } from '../actionTypes/ipirangaPromotion'

const INITIAL_STATE = {
  available: false
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IPIRANGA_PROMOTION_AVAILABLE:
      return { ...state, available: action.payload === true }
    default:
      return state
  }
}
